import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-hourglasshigh",
  "use": "icon-th-hourglasshigh-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-hourglasshigh\">\n<path d=\"M23 3H9C8.46957 3 7.96086 3.21071 7.58579 3.58579C7.21071 3.96086 7 4.46957 7 5V9.5C7.00068 9.81037 7.07326 10.1164 7.21206 10.394C7.35087 10.6716 7.55211 10.9132 7.8 11.1L14.3337 16L7.8 20.9C7.55211 21.0868 7.35087 21.3284 7.21206 21.606C7.07326 21.8836 7.00068 22.1896 7 22.5V27C7 27.5304 7.21071 28.0391 7.58579 28.4142C7.96086 28.7893 8.46957 29 9 29H23C23.5304 29 24.0391 28.7893 24.4142 28.4142C24.7893 28.0391 25 27.5304 25 27V22.545C24.9993 22.2358 24.9273 21.931 24.7896 21.6541C24.652 21.3773 24.4523 21.1359 24.2062 20.9487L17.6588 16L24.2062 11.05C24.4525 10.8632 24.6522 10.6221 24.7899 10.3454C24.9276 10.0688 24.9995 9.76403 25 9.455V5C25 4.46957 24.7893 3.96086 24.4142 3.58579C24.0391 3.21071 23.5304 3 23 3ZM23 5V7H9V5H23ZM23 27H9V22.5L16 17.25L23 22.5438V27ZM16 14.75L9 9.5V9H23V9.455L16 14.75Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-hourglasshigh.svg
// module id = DJrR
// module chunks = 83